'use strict';

var dialog = require('./dialog'),
    page = require('./page'),
    validator = require('./validator'),
    util = require('./util');

function forgetPasswordCallback() {
    validator.init();	
    var $requestPasswordForm = $('[name$="_requestpassword"]');
    var $submit = $requestPasswordForm.find('[name$="_requestpassword_send"]');
    $('body').off('click','[name$="_requestpassword"] [name$="_requestpassword_send"]').on('click','[name$="_requestpassword"] [name$="_requestpassword_send"]', function (e) {
        if (!$requestPasswordForm.valid()) {
            return;
        }
        e.preventDefault();
        var data = $requestPasswordForm.serialize();
        // add form action to data
        data += '&' + $submit.attr('name') + '=';
        // make sure the server knows this is an ajax request
        if (data.indexOf('ajax') === -1) {
            data += '&format=ajax';
        }
        $.ajax({
            type: 'POST',
            url: $requestPasswordForm.attr('action'),
            data: data,
            success: function (response) {
                if (typeof response === 'object' &&
                        !response.success &&
                        response.error === 'CSRF Token Mismatch') {
                    page.redirect(Urls.csrffailed);
                } else if (typeof response === 'string') {
					dialog.$container.html(response);
					if($requestPasswordForm.length>0){
						forgetPasswordCallback();
						util.updateInputFields();
					}
                    /* WCAG_Modal_focus_management */
                	$(".ui-dialog").find(".ui-dialog-titlebar-close").on("mouseenter",function(){
                    	$(this).focus();
                    });
                    $(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("mouseenter");
                }
            },
            failure: function () {
                dialog.$container.html('<h1>' + Resources.SERVER_ERROR + '</h1>');
                /* WCAG_Modal_focus_management */
            	$(".ui-dialog").find(".ui-dialog-titlebar-close").on("mouseenter",function(){
                	$(this).focus();
                });
                $(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("mouseenter");
            }
        });
    });
    $('.close-button').on('click', function(e){
    	e.preventDefault();
    	$(this).closest('.ui-dialog').find('.ui-dialog-titlebar-close').trigger('click');
    });
    $('html').bind('click',function(e){
    	if($('.wrapper-forgot-password').closest('.ui-dialog').hasClass('forgot-password')&& !$(e.target).is('.ui-dialog, a')&& !$(e.target).closest('.ui-dialog').length) {
    		$('.forgot-password').find('.ui-dialog-titlebar-close').trigger('click');
    	}
    });
}
var login = {
    /**
     * @private
     * @function
     * @description init events for the loginPage
     */
    init: function () {
    	
		// Let's make sure that this library only gets initialized one as we're
		// also initializing from app.js for non-login / account pages
		if (this.hasOwnProperty("initialized")) { return; }
		
		// Default that initialization has taken place
		this.initialized = true;
		
		// o-auth binding for which icon is clicked
		$('.oAuthIcon').bind('click', function () {
		
			// We have two copies of the login form(s) on the page, so let's 
			// first find the closet / most relevant oAuthProvider for our form
			var $OAuthProvider = $(this).parent().children("#OAuthProvider");
			
			// Once we have that, set the OAuth provider
			$OAuthProvider.val(this.id);
			
		});

        $('#dwfrm_profile_customer_registertorewards').on('change', function () {
            if ($(this).is(':checked')) {
                $('.login-create-account .rewards-social-login').val('true');
            } else {
                $('.login-create-account .rewards-social-login').val('false');
            }
        });

        // toggle the value of the remember-me checkbox
        $('#dwfrm_login_rememberme').bind('change', function () {
            if ($('#dwfrm_login_rememberme').attr('checked')) {
                $('#rememberme').val('true');
            } else {
                $('#rememberme').val('false');
            }
        });
        
        // hide reset password success message box
        $(document).on('click', '.closeMsg', function(){
        	if($('#header').hasClass('has-reset-header')){
        		$('#header').removeClass('has-reset-header');
        	}
        	$('.reset-message-notify').hide();
        });
        
        $("body").off('click','.password-reset').on('click','.password-reset', function (e) {
        		e.preventDefault();
                // for buttons read data-url and if it is anchor tag read href
                var resetPasswordUrl =  $(e.target).is('a') ? $(e.target).attr('href') : $(e.target).data('url')
           	 	dialog.open({
                    url:resetPasswordUrl,
                    options: {
                    	width: 432,
                    	dialogClass: 'forgot-password',
                        open: function () {
                            forgetPasswordCallback();
                            if ($('#wrapper').hasClass('pt_checkout') && localStorage.getItem('emailSubmitted') !=null) {
                                $('.forgot-password .make-label-absolute').find('input[type="text"]').val(localStorage.getItem('emailSubmitted'));
                            }else if(localStorage.getItem('emailSubmitted') !=null){
                        		$('.forgot-password .make-label-absolute').find('input[type="text"]').val(localStorage.getItem('emailSubmitted'));
                        	}
                       	 /* PXSFCC-4495_WCAG_Modal_focus_management */
                        	$(".ui-dialog").find(".ui-dialog-titlebar-close").on("mouseenter",function(){
                            	$(this).focus();
                            });
                        	
                            $(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("mouseenter");
                        },
                        close: function(e){
                        	$(".ui-dialog.forgot-password").removeClass('forgot-password');
                            dialog.close();
                            if(window.lastClickOrKey === 'key'){
                                $('#password-reset.password-reset').focus().addClass('focus-outline');
                            }
                        }
                    }
               });
               $('.ui-dialog.forgot-password .ui-dialog-titlebar-close')
                    .addClass('btn-ds')
                    .css({
                        position: 'absolute',
                        top: 0,
                        right:0
                    });
        });
        
        /**
         * @function
         * @description updates focus | WCAG login/Sign in validation on focus
         */
       var $loginForm = $('.login-form');
       $('body').off('keydown keypress click mousedown','.login-form .spc-login-btn').on('keydown keypress click mousedown','.login-form .spc-login-btn', function (e) {
           if((e.keyCode && e.keyCode == 13)){
        	   util.validateLoginOnSubmit($loginForm);
           }
       });
       $('body').off('blur').on('blur','.login-form .form-row.username .input-text.email', function (e) {   
    	   util.validateEmailOnFocusOut($loginForm);
       });
       $('body').off('blur').on('blur','.login-form .form-row.password .input-text.password', function (e) {   
    	   util.validatePasswordOnFocusOut($loginForm); 
       });
       $('body').off('input','.login-form .form-row.username .input-text.email').on('input','.login-form .form-row.username .input-text.email', function() { 
	    	$('.login-form').find('.usernameError, .errorInvalidEmail').addClass('hide');
		});
       $('body').off('input','.login-form .form-row.password .input-text.password').on('input','.login-form .form-row.password .input-text.password', function() {  
    	   $('.login-form').find('.passwordError ').hide();
		}); 
    }
}

module.exports = login;
